import * as React from "react";
import LinkJuiceCategorySection from "./LinkJuiceCategorySection";
import { LinkJuiceProps } from "./typings";
import { InsideTabGroupContext } from "components/shared/InsideTabGroupContext/InsideTabGroupContext";
import { UitkHeading } from "uitk-react-text";
import { withStores } from "src/stores";
import { LinkJuiceFlexModuleResult } from "typings/microserviceModels/link-juice-flex-module";
import { LazyLoad } from "src/components/utility/LazyLoad/LazyLoad";

function LinkJuice(props: LinkJuiceProps) {
  const { flexTemplateNode, flexModuleModelStore, context } = props;

  if (!flexTemplateNode || !flexModuleModelStore) {
    return null;
  }

  const { id, options } = flexTemplateNode;
  const { fmId, fmTitleId } = options;
  const model = flexModuleModelStore.getModel(flexTemplateNode.id) as LinkJuiceFlexModuleResult | null;

  if (!model) {
    return null;
  }

  const { title, categories, collapsed, displayColumns } = model;

  if (!(title && categories && categories.length)) {
    return null;
  }

  const insideTabGroup = React.useContext(InsideTabGroupContext);
  const paddingTopClassName = insideTabGroup ? "" : " all-t-padding-three";

  return (
    <LazyLoad context={context}>
      <div
        className={`LinkJuice all-cell-1-1 uitk-cell${paddingTopClassName}`}
        id={id}
        data-fm={fmId}
        data-fm-title-id={fmTitleId}
      >
        {!insideTabGroup && (
          <div className="all-y-padding-three">
            <UitkHeading level={2} size={600}>
              {title}
            </UitkHeading>
          </div>
        )}
        {categories.map(
          (category) =>
            category.name && (
              <LinkJuiceCategorySection
                key={category.name}
                category={category}
                collapsed={collapsed || false}
                displayColumns={displayColumns}
              />
            )
        )}
      </div>
    </LazyLoad>
  );
}

export default withStores("flexModuleModelStore")(LinkJuice);
